import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/fleets/$id/reports/")({
  staticData: {
    title: "common.reports",
  },
});
